import React from 'react'
import './TeamWork.css'
import Team_1 from '../../assests/Ellipse 1.png'
import Team_5 from '../../assests/Ellipse 1 (1).png'
import Team_4 from '../../assests/Ellipse 2 (1).png'
import Team_3 from '../../assests/Ellipse 2.png'
import Team_6 from '../../assests/Ellipse 3.png'
import Team_2 from '../../assests/Ellipse 2 (2).png'
import { TiSocialFacebook } from "react-icons/ti";
import { FaTwitter } from "react-icons/fa";



const TeamWork = () => {
  return (
    <div className='teamwork'>
      <div className="teamwork-container">
        <div className="teamwork-header">
          <div className="teamwork-badge">
              <p>TEAMWORK</p>
          </div>
            <h2>Meet The Team</h2>
            <p className='header-text'>Highly professional team capable of running your business across all digital channels.</p>
        </div>
        <div className="teamwork-members">
            <div className="members">
                <img src={Team_1} alt="" />
                <h5>Marculey Herring</h5>
                <p>CEO & Founder</p>
                <small>Dance is the hidden language <br /> of the soul.</small>
              <div className="member-icons">
                <a href="#">
                  <TiSocialFacebook className='icons'/>
                </a>
                <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target='_blank'>
                  <FaTwitter className='icons'/>
                </a>
              </div>
            </div>
            <div className="members">
                <img src={Team_2} alt="" />
                <h5>Ivan Mathews</h5>
                <p>CTO</p>
                <small>Everything you’ve ever wanted is on <br /> the other side of fear.</small>
              <div className="member-icons">
                <a href="#">
                  <TiSocialFacebook className='icons'/>
                </a>
                <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target='_blank'>
                  <FaTwitter className='icons'/>
                </a>
              </div>
            </div>
            <div className="members">
                <img src={Team_3} alt="" />
                <h5>Elen Benitez</h5>
                <p>CPO</p>
                <small>The only way to do great work is to <br /> love what you do.</small>
              <div className="member-icons">
                <a href="#">
                  <TiSocialFacebook className='icons'/>
                </a>
                <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target='_blank'>
                  <FaTwitter className='icons'/>
                </a>
              </div>
            </div>
            <div className="members">
                <img src={Team_4} alt="" />
                <h5>Marculey Herring</h5>
                <p>Customer Success</p>
                <small>There are no traffic jams along <br /> the extra mile.</small>
              <div className="member-icons">
                <a href="#">
                  <TiSocialFacebook className='icons'/>
                </a>
                <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target='_blank'>
                  <FaTwitter className='icons'/>
                </a>
              </div>
            </div>
            <div className="members">
                <img src={Team_5} alt="" />
                <h5>Alya Levine</h5>
                <p>Backend Developer</p>
                <small>The mind is everything. What you <br /> think you become.</small>
              <div className="member-icons">
                <a href="#">
                  <TiSocialFacebook className='icons'/>
                </a>
                <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target='_blank'>
                  <FaTwitter className='icons'/>
                </a>
              </div>
            </div>
            <div className="members">
                <img src={Team_6} alt="" />
                <h5>Rose Hernandez</h5>
                <p>IOS Developer</p>
                <small>Whether you think you can or you <br /> think you can’t, you’re right.</small>
              <div className="member-icons">
                <a href="#">
                  <TiSocialFacebook className='icons'/>
                </a>
                <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target='_blank'>
                  <FaTwitter className='icons'/>
                </a>
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default TeamWork
